/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Salary_Factors_TitleInputs */

const en_salary_factors_title = /** @type {(inputs: Salary_Factors_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Key Factors Affecting Salary`)
};

const de_salary_factors_title = /** @type {(inputs: Salary_Factors_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Wichtige Faktoren, die das Gehalt beeinflussen`)
};

const fr_salary_factors_title = /** @type {(inputs: Salary_Factors_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Facteurs clés influençant le salaire`)
};

const es_salary_factors_title = /** @type {(inputs: Salary_Factors_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Factores clave que afectan el salario`)
};

const it_salary_factors_title = /** @type {(inputs: Salary_Factors_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Fattori chiave che influenzano lo stipendio`)
};

const nl_salary_factors_title = /** @type {(inputs: Salary_Factors_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Belangrijke factoren die het salaris beïnvloeden`)
};

const pl_salary_factors_title = /** @type {(inputs: Salary_Factors_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Kluczowe czynniki wpływające na wynagrodzenie`)
};

const fi_salary_factors_title = /** @type {(inputs: Salary_Factors_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Palkkaan vaikuttavat keskeiset tekijät`)
};

const da_salary_factors_title = /** @type {(inputs: Salary_Factors_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Nøglefaktorer der påvirker løn`)
};

const sv_salary_factors_title = /** @type {(inputs: Salary_Factors_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Nyckelfaktorer som påverkar lön`)
};

/**
* | output |
* | --- |
* | "Key Factors Affecting Salary" |
*
* @param {Salary_Factors_TitleInputs} inputs
* @param {{ locale?: "en" | "de" | "fr" | "es" | "it" | "nl" | "pl" | "fi" | "da" | "sv" }} options
* @returns {LocalizedString}
*/
export const salary_factors_title = /** @type {((inputs?: Salary_Factors_TitleInputs, options?: { locale?: "en" | "de" | "fr" | "es" | "it" | "nl" | "pl" | "fi" | "da" | "sv" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Salary_Factors_TitleInputs, { locale?: "en" | "de" | "fr" | "es" | "it" | "nl" | "pl" | "fi" | "da" | "sv" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return de_salary_factors_title(inputs)
	if (locale === "fr") return fr_salary_factors_title(inputs)
	if (locale === "es") return es_salary_factors_title(inputs)
	if (locale === "it") return it_salary_factors_title(inputs)
	if (locale === "nl") return nl_salary_factors_title(inputs)
	if (locale === "pl") return pl_salary_factors_title(inputs)
	if (locale === "fi") return fi_salary_factors_title(inputs)
	if (locale === "da") return da_salary_factors_title(inputs)
	if (locale === "sv") return sv_salary_factors_title(inputs)
	return en_salary_factors_title(inputs)
});